import React, { useMemo } from "react";
import { MONTH_OPTIONS, PERIOD_TYPE_OPTIONS } from "./utils";

export default function AgingFilter({ filters, setFilters, disabled = false }) {
  const currentYear = useMemo(() => new Date().getFullYear(), []);
  const yearOptions = useMemo(
    () => Array.from({ length: 6 }, (_, idx) => currentYear - idx),
    [currentYear]
  );

  return (
    <div className="flex flex-row flex-wrap justify-start items-end gap-2 text-xs">
      <div className="flex flex-col shrink-0">
        <span className="text-[11px] text-zinc-600">Period</span>
        <select
          className="h-10 min-w-[184px] border border-zinc-200 rounded-sm bg-white px-2"
          value={filters.period_type}
          disabled={disabled}
          onChange={(event) =>
            setFilters({ ...filters, period_type: event.target.value })
          }
        >
          {PERIOD_TYPE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      <div className="flex flex-col shrink-0">
        <span className="text-[11px] text-zinc-600">Year</span>
        <select
          className="h-10 min-w-[96px] border border-zinc-200 rounded-sm bg-white px-2"
          value={filters.year}
          disabled={disabled}
          onChange={(event) =>
            setFilters({ ...filters, year: Number(event.target.value) })
          }
        >
          {yearOptions.map((year) => (
            <option key={year} value={year}>
              {year}
            </option>
          ))}
        </select>
      </div>

      {filters.period_type === "month" && (
        <div className="flex flex-col shrink-0">
          <span className="text-[11px] text-zinc-600">Month</span>
          <select
            className="h-10 min-w-[104px] border border-zinc-200 rounded-sm bg-white px-2"
            value={filters.month}
            disabled={disabled}
            onChange={(event) =>
              setFilters({ ...filters, month: Number(event.target.value) })
            }
          >
            {MONTH_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      )}

      <div className="flex flex-col shrink-0">
        <span className="text-[11px] text-zinc-600">Ranking size</span>
        <select
          className="h-10 min-w-[96px] border border-zinc-200 rounded-sm bg-white px-2"
          value={filters.top_size}
          disabled={disabled}
          onChange={(event) =>
            setFilters({ ...filters, top_size: Number(event.target.value) })
          }
        >
          {[5, 10, 20, 50, 100].map((size) => (
            <option key={size} value={size}>
              Top {size}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
}
